import { ValueFormatterType } from './types';
import { summaryType } from '../../pages/dashboard/constants';

export const summaryTypeToFormatter: Record<string, ValueFormatterType> = {
  [summaryType.raisedAmount]: 'currency',
  [summaryType.saleAmount]: 'currency',
  [summaryType.donationAmount]: 'currency',
  [summaryType.numberOfSoldTickets]: 'integer',
  [summaryType.numberOfDonations]: 'integer',
  [summaryType.numberOfFundraisingPages]: 'integer',
  [summaryType.participantCount]: 'integer'
};
